/**
 * 游戏图标 & 引擎图标映射配置
 * 将游戏名称 / 引擎名称映射到对应的图标文件
 */

// ─── Game Icons ───
import EightBallPool from '@/pages/dashboard/assets/svg/sth/8pool.png';
import B4B2 from '@/pages/dashboard/assets/svg/sth/b4b2.png';
import ConanExiles from '@/pages/dashboard/assets/svg/sth/conan_exiles.png';
import D7 from '@/pages/dashboard/assets/svg/sth/d7.png';
import Darktide from '@/pages/dashboard/assets/svg/sth/darktide.png';
import DenOfWolves from '@/pages/dashboard/assets/svg/sth/den_of_wolves.png';
import DL from '@/pages/dashboard/assets/svg/sth/dl.png';
import DL2 from '@/pages/dashboard/assets/svg/sth/dl2.png';
import DLO from '@/pages/dashboard/assets/svg/sth/dlo.png';
import DLTB from '@/pages/dashboard/assets/svg/sth/dltb.png';
import DLTB2 from '@/pages/dashboard/assets/svg/sth/dltb2.png';
import DuneAwakening from '@/pages/dashboard/assets/svg/sth/dune_awakening.png';
import Exoborne from '@/pages/dashboard/assets/svg/sth/exoborne.png';
import GST from '@/pages/dashboard/assets/svg/sth/gst.png';
import GTFO from '@/pages/dashboard/assets/svg/sth/gtfo.png';
import HelldiversSeries from '@/pages/dashboard/assets/svg/sth/helldivers_series.png';
import Hydra from '@/pages/dashboard/assets/svg/sth/hydra.png';
import Nightingale from '@/pages/dashboard/assets/svg/sth/nightingale.png';
import NIKKE from '@/pages/dashboard/assets/svg/sth/nikke.png';
import POE from '@/pages/dashboard/assets/svg/sth/poe.png';
import POE2 from '@/pages/dashboard/assets/svg/sth/poe2.png';
import Project070 from '@/pages/dashboard/assets/svg/sth/project_070.png';
import Project071 from '@/pages/dashboard/assets/svg/sth/project_071.png';
import ProjectSpirits from '@/pages/dashboard/assets/svg/sth/project_spirits.png';
import ProjectWest from '@/pages/dashboard/assets/svg/sth/project_west.png';
import Soulframe from '@/pages/dashboard/assets/svg/sth/soulframe.png';
import Sparrow from '@/pages/dashboard/assets/svg/sth/sparrow.png';
import StellarBlade from '@/pages/dashboard/assets/svg/sth/stellar_blade.png';
import SubwaySurfer from '@/pages/dashboard/assets/svg/sth/subway_suffer.png';
import TheCube from '@/pages/dashboard/assets/svg/sth/the_cube.png';
import TripleMatch3D from '@/pages/dashboard/assets/svg/sth/triple_match_3d.png';
import VRising from '@/pages/dashboard/assets/svg/sth/v_rising.png';
import VRising2 from '@/pages/dashboard/assets/svg/sth/v_rising_2.png';
import Warframe from '@/pages/dashboard/assets/svg/sth/warframe.png';
import Wonderland from '@/pages/dashboard/assets/svg/sth/wonderland.png';
import Helldrivers2 from '@/pages/dashboard/assets/svg/sth/helldivers_2.png';

// ─── Engine Icons ───
import UnrealEngine from '@/pages/dashboard/assets/svg/sth/unreal_engine.png';
import Unity from '@/pages/dashboard/assets/svg/sth/unity.png';
import Unity6 from '@/pages/dashboard/assets/svg/sth/unity_6.png';
import Cocos from '@/pages/dashboard/assets/svg/sth/cocos.png';
import ProprietaryEngine from '@/pages/dashboard/assets/svg/sth/proprietary_engine.png';

/**
 * 游戏名称 → 图标映射
 * key 为 studio.games[] 中的游戏名称（需完全匹配）
 */
export const GAME_ICON_MAP: Record<string, string> = {
  // Miniclip
  '8 Ball Pool': EightBallPool,
  'Subway Surfers': SubwaySurfer,
  'Triple Match 3D': TripleMatch3D,

  // DE
  Warframe,
  Soulframe,

  // GGG
  POE,
  POE2,

  // Techland
  'Project West': ProjectWest,
  DLO,
  DLTB2,
  DLTB,
  DL,
  DL2,

  // 10C
  'Den of Wolves': DenOfWolves,

  // Stunlock
  'V Rising': VRising,
  'V Rising 2': VRising2,
  GTFO,

  // Turtle Rock
  B4B2,

  // Sharkmob
  Exoborne,

  // Funcom
  'Dune: Awakening': DuneAwakening,
  'Conan Exiles': ConanExiles,

  // Yager
  Sparrow,

  // Mundfish
  'The Cube': TheCube,

  // Lighthouse
  Wonderland,

  // Sumo
  D7,

  // Fatshark
  Darktide,
  Hydra,

  // Platinum
  'Project 070': Project070,
  'Project 071': Project071,

  // Arrowhead
  'Helldivers': HelldiversSeries,
  'Helldivers 2': Helldrivers2,

  // Joy Workshop
  GST,

  // Inflexion
  Nightingale,

  // Shiftup / Yongxing
  Nikke: NIKKE,
  'Stellar Blade': StellarBlade,
  'Project Spirits': ProjectSpirits,
};

/**
 * 引擎名称 → 图标映射
 * key 为引擎名称（与 game_engine[] 数组中的值完全匹配）
 */
export const ENGINE_ICON_MAP: Record<string, string> = {
  UE5: UnrealEngine,
  'Unreal Engine': UnrealEngine,
  Unity,
  'Unity 6': Unity6,
  Cocos,
  'Proprietary engine': ProprietaryEngine,
};
